(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header-countdown"] && !Shopify.designMode) return;
  try {
    
  (function() {
    function initCountdown(container) {
      var end = new Date(container.getAttribute('data-end-date')).getTime();
      var parts = {
        days: container.querySelector('.days .value'),
        hours: container.querySelector('.hours .value'),
        minutes: container.querySelector('.minutes .value'),
        seconds: container.querySelector('.seconds .value')
      };
      function update() {
        var now = new Date().getTime();
        var diff = end - now;
        if (diff <= 0) { clearInterval(interval); return; }
        var d = Math.floor(diff / (1000*60*60*24));
        var h = Math.floor((diff / (1000*60*60)) % 24);
        var m = Math.floor((diff / (1000*60)) % 60);
        var s = Math.floor((diff / 1000) % 60);
        if (parts.days) parts.days.textContent = String(d).padStart(2,'0');
        if (parts.hours) parts.hours.textContent = String(h).padStart(2,'0');
        if (parts.minutes) parts.minutes.textContent = String(m).padStart(2,'0');
        if (parts.seconds) parts.seconds.textContent = String(s).padStart(2,'0');
      }
      update();
      var interval = setInterval(update, 1000);
    }
    document.addEventListener('DOMContentLoaded', function() {
      document.querySelectorAll('.countdown-timer').forEach(initCountdown);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
